import qs from '@bundled-es-modules/qs'
import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

/**
 * This redirect middleware must execute only on the client to handle navigation across the website and still has the redirects handled by Vue.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server || !to?.name || !to?.path || to.path === '/') {
    return
  }

  const pathname = to?.path?.toLowerCase().replace(/\/+$/, '') || '/'
  /**
   * Prevent any non valid urls
   */
  if (to.path && pathname !== to.path) {
    let resultFullPath = pathname

    if (to.query && Object.keys(to.query).length > 0) {
      resultFullPath += `?${qs.stringify(to.query)}`
    }

    return navigateTo(resultFullPath, {
      redirectCode: 301,
    })
  }

  /**
   * Find the redirect in the database
   */
  if (to.fullPath) {
    try {
      const { view } = useRedirectApi()

      const { data } = await view(to.fullPath)

      if (data?.target_url && to.fullPath !== data.target_url) {
        if (data?.query_parameters === 'ignore_pass') {
          const resultUrl = `${data.target_url}?${qs.stringify(to.query)}`

          return navigateTo(resultUrl, {
            redirectCode: parseInt(data?.redirect_type || 307),
            external: true,
          })
        }
        else {
          return navigateTo(data.target_url, {
            redirectCode: parseInt(data?.redirect_type || 307),
            external: true,
          })
        }
      }
    }
    catch {
      // Empty catch statement to skip the 404 error from the redirector
    }
  }

  /**
   * Handle redirects for aspx urls
   */
  if (to.name === 'news-year-month-day-slug' && to.path.endsWith('.aspx')) {
    return navigateTo(to.path.substring(0, to.path.length - 5), {
      redirectCode: 301,
    })
  }

  /**
   * Handle redirect for search results
   */
  if (to.path === '/searchresults.aspx') {
    return navigateTo(
      {
        name: 'search',
      },
      {
        redirectCode: 301,
      },
    )
  }

  /**
   * Handle redirect for all .aspx urls
   */
  if (to.path.endsWith('.aspx')) {
    return navigateTo(to.path.substring(0, to.path.length - 5), {
      redirectCode: 301,
    })
  }
})
